const StatusIndicator: React.FC<StatusIndicatorProps> = ({ color, text }) => {
  return (
    <div className="flex items-center gap-2">
      <span className={`w-2 h-2 bg-${color}-500 rounded-full inline-block`}></span>
      <span className={`label text-${color}-500`}>{text}</span>
    </div>
  );
};
export type StatusIndicatorProps = {
  color: string;
  text: string;
};

export default StatusIndicator;
